/**
 * Calculate bucket-related values based on range in years
 */
export function calculateBucketValues(rangeInPeriods?: number[] | null) {
  const DEFAULT_VALUES = {
    numberOfBuckets: 0,
    defaultWeight: 0,
    defaultMin: 0,
    defaultMax: 0,
  }

  if (!rangeInPeriods?.length || rangeInPeriods.length !== 2) {
    return DEFAULT_VALUES
  }

  const [startPeriod, endPeriod] = rangeInPeriods
  const TOTAL_PERCENTAGE = 100
  const BUFFER_PERCENTAGE = 3

  // biome-ignore lint/style/noNonNullAssertion: suppress noUncheckedIndexedAccess
  const numberOfBuckets = endPeriod! - startPeriod!
  const defaultWeight = TOTAL_PERCENTAGE / numberOfBuckets
  const defaultMin = Math.max(0, defaultWeight - BUFFER_PERCENTAGE)
  const defaultMax = defaultWeight + BUFFER_PERCENTAGE

  return {
    numberOfBuckets,
    defaultWeight,
    defaultMin,
    defaultMax,
  }
}
